import { render, staticRenderFns } from "./message-sidebar.vue?vue&type=template&id=e212ae42&"
import script from "./message-sidebar.vue?vue&type=script&lang=js&"
export * from "./message-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs-edu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e212ae42')) {
      api.createRecord('e212ae42', component.options)
    } else {
      api.reload('e212ae42', component.options)
    }
    module.hot.accept("./message-sidebar.vue?vue&type=template&id=e212ae42&", function () {
      api.rerender('e212ae42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/message/message-sidebar.vue"
export default component.exports